import React from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { ButtonBorderRadius } from '@apply/components/src/components/controls/Button';
import { ILoanSummaryDashboardExportRequest } from '@apply/api/src/api/loanApi';
import { LoanApi } from '@apply/api';
import { applicationInsights } from '../../../../../../ApplicationInsights';
import FileDownload from 'js-file-download';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export interface ExportDashboardButtonProps {
    closed: {
        byMonthPivotMode: any;
        byPocPivotMode: any;
        pocByMonthClosedMonth: string | null;
        availableClosedMonths: { key: string; display: string }[];
    };
    outstanding: {
        byMonthPivotMode: any;
        byPocPivotMode: any;
    };
}

export const ExportDashboardButton: React.FC<ExportDashboardButtonProps> = ({ closed, outstanding }) => {
    const loanApi = new LoanApi.LoanApi(applicationInsights);

    const handleClick = async () => {
        const criteria: ILoanSummaryDashboardExportRequest = {
            closedByMonthDisplayType: closed.byMonthPivotMode,
            closedByPOCDisplayType: closed.byPocPivotMode,
            closedSelectedMonth: closed.pocByMonthClosedMonth,

            outstandingByMonthDisplayType: outstanding.byMonthPivotMode,
            outstandingByPOCDisplayType: outstanding.byPocPivotMode,
        };

        try {
            const date = new Date();
            const dateFormat = `${date.getUTCMonth() + 1}-${date.getUTCDate()}-${date.getUTCFullYear()}-${date.getUTCHours()}-${date.getUTCMinutes()}-${date.getUTCSeconds()}`;
            const fileName = `BFIA_LoanSummaryOutstanding_${dateFormat}`;

            const response = await loanApi.exportLoanSummaryDashboardData(criteria);

            // Download file
            FileDownload(response, `${fileName}.xlsx`);
        } catch (err) {
            console.error('Export failed:', err);
        }
    };

    return (
        <Button
            id='exportOutstandingDashboardButton'
            dataTestid='exportOutstandingDashboardButton'
            theme={ButtonTheme.SectionHeaderBarButton_Blue}
            width='100px'
            height='32px'
            borderRadius={ButtonBorderRadius.Small}
            handleClick={handleClick}
            icon={faDownload}
        >
            Export
        </Button>
    );
};
